import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IExhibitorQutationRFQStatsPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any[]
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const exhibitorQutationRFQStatsSlice = createSlice({
    name: 'company-statistics/exhibitor-qutation-RFQ-stats',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IExhibitorQutationRFQStatsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const exhibitorQutationRFQStatsActions = exhibitorQutationRFQStatsSlice.actions
export default exhibitorQutationRFQStatsSlice.reducer
